module.exports = __webpack_public_path__ + "static/idinsight-645da80f7303fe9c357749c9119c955b.png";